/**
 * Builds a comma-separated string from an array of IDs, suitable for use as a query parameter.
 *
 * @param ids - An array of numbers or strings to be joined. Can be undefined.
 * @returns A comma-separated string of the IDs. Returns an empty string if the input array is undefined or empty.
 */
export function idsQueryParamsBuilder(ids: (number | string)[] | undefined): string {
  if (!ids || ids.length === 0) return '';

  return ids.join(',');
}
